import { render } from "./NoAuthorizationExpertStats.vue?vue&type=template&id=86135964"
import script from "./NoAuthorizationExpertStats.vue?vue&type=script&lang=js"
export * from "./NoAuthorizationExpertStats.vue?vue&type=script&lang=js"

import "./NoAuthorizationExpertStats.vue?vue&type=style&index=0&id=86135964&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__